module.exports = __webpack_public_path__ + "static/media/token-busd.143cb0e2.svg";